// extracted by mini-css-extract-plugin
export default {"container":"document-description_container__24aMR"};